// extracted by mini-css-extract-plugin
export var content = "_6a-3";
export var list = "_6a-4";
export var settingsContent = "_6a-7";
export var settingsPanel = "_6a-8";
export var state = "_6a-6";
export var triggerBadge = "_6a-2";
export var triggerButton = "_6a-1";
export var triggerShell = "_6a-0";
export var unreadDot = "_6a-5";